var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMidiasModeracao)?_c('Colaboracoes'):(_vm.$store.state.moderacao.modoModeracao == 1)?_c('Noticias'):(_vm.$store.state.moderacao.modoModeracao == 2)?_c('Enquetes'):(_vm.$store.state.moderacao.modoModeracao == 3)?_c('Cameras'):_c('Cronometro')
}
var staticRenderFns = []

export { render, staticRenderFns }